module.exports = __webpack_public_path__ + "img/web3icon3.7304c14c.png";